<script>
  import Tailwind from "./Tailwind.svelte";
  import { onMount, onDestroy } from "svelte";
  import { getTime, getTimers } from "../utils/utils";
  import { screenLock } from "../utils/screenLock";
  import CircularProgressBar from "./CircularProgressBar.svelte";
  import CurrentTime from "./CurrentTime.svelte";
  import TotalTime from "./TotalTime.svelte";

  export let setup;
  export let pause;
  export let done;

  let timer = null;
  let totalSec;
  let timeName = "work";
  let duration;
  let viewPortWidth = 65;
  let beep = new Audio("sounds/single_beep.ogg");
  let longBeep = new Audio("sounds/long_beep.ogg");

  onMount(() => {
    screenLock.getScreenLock();
    screenLock.addVisibilityListener();
    let timers = getTimers(setup);
    if (timers.length !== 0) {
      let prepareTimer = timers[0];
      totalSec = prepareTimer.sec;
      duration = prepareTimer.sec;
      timeName = prepareTimer.name;
      timer = setInterval(() => {
        if (!pause) {
          totalSec--;
        }
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    } else {
      totalSec = 0;
      timer = setInterval(() => {
        if (!pause) {
          totalSec++;
        }
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    }
  });

  onDestroy(() => {
    if (timer) {
      clearInterval(timer);
    }
    screenLock.release();
    screenLock.removeVisibilityListener();
  });

  $: timerText = getTime(totalSec);

  $: {
    if (totalSec === 0) {
      duration = 60;
      timeName = "work";
      clearInterval(timer);
      timer = setInterval(() => {
        if (!pause) {
          totalSec++;
        }
      }, 1000);
    }
    if (totalSec % 60 === 0) {
      duration = 60;
      beep.currentTime = 0;
      beep.play();
    }
    if (totalSec >= 3600) {
      viewPortWidth = 100;
    }
  }
</script>

<div
  class="h-full w-full sm:w-auto flex flex-1 justify-around items-end flex-row sm:flex-col self-center uppercase"
>
  <CurrentTime />
  <TotalTime bind:done bind:pause />
</div>
<div class="h-full w-auto flex justify-center items-cente relative">
  <div
    class="absolute inset-0 flex-col uppercase flex justify-center items-center"
  >
    <h3
      class="w-3/5 overflow-hidden inline-block text-xl sm:text-2xl lg:text-3xl text-center font-semibold"
    >
      {timeName}
    </h3>
    <div class="w-full h-auto">
      <svg viewBox="0 0 {viewPortWidth} 20" fill="currentColor">
        <text
          x="50%"
          y="50%"
          dominant-baseline="middle"
          text-anchor="middle"
          class="font-mono font-semibold text-green-300">{timerText}</text
        >
      </svg>
    </div>
    {#if setup.name}
      <h3
        class="w-3/5 overflow-hidden inline-block text-xl sm:text-2xl lg:text-4xl text-center font-semibold"
      >
        {setup.name}
      </h3>
    {/if}
  </div>
  <CircularProgressBar bind:duration bind:pause />
</div>
<div
  class="h-full w-full sm:w-max flex-1 flex justify-start items-cente flex-col self-center sm:flex-row uppercase"
>
  <h3 class="self-center">
    {#if setup.description}
      <span
        class="text-xl md:text-2xl 2xl:text-4xl text-shadow-lg font-semibold text-green-300 whitespace-pre-wrap"
      >
        {setup.description}
      </span>
    {/if}
  </h3>
</div>
